import { API_URL } from './config';

export const messagesService = {
    list: async (matchId: string) => {
        const res = await fetch(`${API_URL}/matches/${matchId}/messages`);
        if (!res.ok) throw new Error("Failed to load messages");
        const messages = await res.json();

        const baseUrl = API_URL.replace(/\/api$/, '');
        return messages.map((m: any) => {
            // Fix avatar URL
            if (m.profile_pic_url && m.profile_pic_url.startsWith('/')) {
                m.profile_pic_url = `${baseUrl}${m.profile_pic_url}`;
            }
            return m;
        });
    },
    listForCircle: async (circleId: string) => {
        const { getAuthHeaders } = await import('./config'); // Dynamic import to avoid cycles if any
        const res = await fetch(`${API_URL}/circles/${circleId}/messages`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to load messages");
        const messages = await res.json();

        const baseUrl = API_URL.replace(/\/api$/, '');
        return messages.map((m: any) => {
            if (m.profile_pic_url && m.profile_pic_url.startsWith('/')) {
                m.profile_pic_url = `${baseUrl}${m.profile_pic_url}`;
            }
            return m;
        });
    },
    send: async (matchId: string, userId: string, content: string) => {
        const res = await fetch(`${API_URL}/matches/${matchId}/messages`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId, content })
        });
        if (!res.ok) throw new Error("Failed to send message");
        return res.json();
    },
    sendForCircle: async (circleId: string, userId: string, content: string) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/circles/${circleId}/messages`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ user_id: userId, content })
        });
        if (!res.ok) throw new Error("Failed to send message");
        return res.json();
    },

    // --- Direct Messages (Conversations) ---
    createConversation: async (otherUserId: string, clubId?: number) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/conversations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({
                user_id: localStorage.getItem('user_id'), // Helper
                other_user_id: otherUserId,
                club_id: clubId
            })
        });
        if (!res.ok) throw new Error("Failed to create conversation");
        return res.json();
    },

    createSupport: async (clubId: string) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/messages/support`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ club_id: clubId })
        });
        if (!res.ok) throw new Error("Failed to contact club");
        return res.json();
    },

    listConversations: async () => {
        const { getAuthHeaders } = await import('./config');
        const userId = localStorage.getItem('user_id');
        const res = await fetch(`${API_URL}/conversations?user_id=${userId}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to list conversations");
        const conversations = await res.json();

        const baseUrl = API_URL.replace(/\/api$/, '');
        return conversations.map((c: any) => {
            if (c.other_user_pic && c.other_user_pic.startsWith('/')) {
                c.other_user_pic = `${baseUrl}${c.other_user_pic}`;
            }
            return c;
        });
    },

    // updateLastMessageAt removed (unused)

    markAsRead: async (conversationId: string) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/conversations/${conversationId}/read`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({})
        });
        if (!res.ok) throw new Error("Failed to mark messages as read");
        return res.json();
    },

    listDirect: async (conversationId: string) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/conversations/${conversationId}/messages`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to load messages");
        const messages = await res.json();

        const baseUrl = API_URL.replace(/\/api$/, '');
        return messages.map((m: any) => {
            if (m.profile_pic_url && m.profile_pic_url.startsWith('/')) {
                m.profile_pic_url = `${baseUrl}${m.profile_pic_url}`;
            }
            return m;
        });
    },

    sendDirect: async (conversationId: string, userId: string, content: string) => {
        const { getAuthHeaders } = await import('./config');
        const res = await fetch(`${API_URL}/conversations/${conversationId}/messages`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ user_id: userId, content })
        });
        if (!res.ok) throw new Error("Failed to send message");
        return res.json();
    }
};
